export const desktopSideNavWidth = 300
